import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Lightbulb, AlertTriangle, TrendingUp, X } from 'lucide-react';
import { getDashboardInsights, dismissInsight } from '../utils/api';

export const DashboardInsights = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    getDashboardInsights()
      .then((res) => setData(res.data))
      .catch(() => setData({ insights: [], has_data: false }));
  }, []);

  const dismiss = async (key) => {
    setData((d) => ({ ...d, insights: d.insights.filter((i) => i.key !== key) }));
    try { await dismissInsight(key); } catch (e) { /* already removed locally */ }
  };

  if (!data) return null;

  return (
    <div className="card" data-testid="dashboard-insights-panel">
      <h2 className="text-xl font-bold text-white flex items-center gap-2 mb-4">
        <Lightbulb size={18} className="text-orange" /> Insights
      </h2>
      {data.insights.length === 0 ? (
        <p className="text-sm text-gray py-6 text-center" data-testid="insights-empty">
          {data.has_data
            ? "You're all caught up — no new insights right now."
            : 'Insights will appear here once your campaigns have some activity.'}
        </p>
      ) : (
        <div className="space-y-2">
          {data.insights.map((ins) => (
            <div
              key={ins.key}
              data-testid={`insight-${ins.type}`}
              className={`flex items-start gap-3 p-3 rounded-lg border ${
                ins.type === 'success' ? 'border-lime/30 bg-lime/5' : 'border-orange/30 bg-orange/5'
              }`}
            >
              {ins.type === 'success' ? (
                <TrendingUp size={16} className="text-lime shrink-0 mt-0.5" />
              ) : (
                <AlertTriangle size={16} className="text-orange shrink-0 mt-0.5" />
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm text-light-gray leading-snug">{ins.message}</p>
                {ins.link && (
                  <Link to={ins.link} className={`text-xs font-semibold hover:underline ${ins.type === 'success' ? 'text-lime' : 'text-orange'}`}>
                    Take a look →
                  </Link>
                )}
              </div>
              <button
                data-testid={`insight-dismiss-${ins.key}`}
                onClick={() => dismiss(ins.key)}
                className="text-gray hover:text-white shrink-0"
                title="Dismiss"
              >
                <X size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
